import React, { useState } from 'react';
import './AdminPage.css';
import AdminListingManager from './AdminListingManager';
import AdminUserManager from './AdminUserManager';
import AdminViewingAnalytics from './AdminViewingAnalytics';
import AdminServiceAnalytics from './AdminServiceAnalytics';

const AdminPage = () => {
  const [activeTab, setActiveTab] = useState('listings');

  const tabs = [
    { id: 'listings', label: 'Зарын удирдлага' },
    { id: 'users', label: 'Хэрэглэгч удирдлага' },
    { id: 'viewing-analytics', label: 'Үзэх түүх анализ' },
    { id: 'service-analytics', label: 'Үйлчилгээ судалгаа' }
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'listings':
        return <AdminListingManager />;
      case 'users':
        return <AdminUserManager />;
      case 'viewing-analytics':
        return <AdminViewingAnalytics />;
      case 'service-analytics':
        return <AdminServiceAnalytics />;
      default:
        return null;
    }
  };

  return (
    <div className="admin-page">
      <div className="admin-header">
        <h1>Админ удирдлага</h1>
        <p>Түүхэн зар, хэрэглэгч болон үйлчилгээ удирдах</p>
      </div>

      <div className="admin-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`admin-tab-button ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="admin-content">
        {renderContent()}
      </div>
    </div>
  );
};

export default AdminPage;
